import axios from "axios";
import {app} from "../konstants";

export const loadMyAccount = function(success, failure) {
    success({
        id: app.accountId,
    });
};

export const saveMyAccount = function(account, success, failure) {
    success({});
};

export const uploadImage = function(accountId, logo, success, failure) {
    success(null);
};

export const fulfillInventor = (sessionId, password, success, failure) => {
    const url = "/api/v1/account/fulfillInventor";

    axios.post(url, {
        sessionId: sessionId,
        password: password,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};
